import React from 'react';
import { connect } from 'react-redux';
import CartCount from '../Components/CartCount';

const CartCountContainer = (props) => <CartCount {...props} />;

const mapStateToProps = (state) => {
  const { cart } = state;
  return {
    ...cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CartCountContainer);
